import React, { useState } from "react";
import { AXIOS_DELETE } from "../../server/api/crud";
import DashboardDocumenten from "../../Componenten/DashboardDocumenten";
import UploadDocumenten from "../../Componenten/Calender/UploadDocumenten";
import FilterNavigation from "../../Componenten/Dashboard/FilterNavigation";
import { DocumentIcon, TableCellsIcon } from "@heroicons/react/24/outline";
import Swal from "sweetalert2";
import { deleteObject, ref } from "firebase/storage";
import { storage } from "../../firebase/firebase";
import FileCardAdvies from "../../Componenten/MiniCards/FileCardAdvies";
import SelectPatienten from "../../Componenten/SelectPatienten";

const filters = [
  { value: 2, name: "block", icon: DocumentIcon, color: "text-green-500" },
  { value: 1, name: "list", icon: TableCellsIcon, color: "text-green-500" },
];

const AdviezenAdmin = ({
  userdetails,
  attachments,
  setRefresh,
  setPatient,
  patient,
  patienten,
  type = "uploads",
}) => {
  const [view, setView] = useState(filters[0]);
  const [open, setOpen] = useState(false);

  const deleteDocument = async (item) => {
    const result = await Swal.fire({
      title: "Bent u zeker deze document te willen verwijderen",
      showDenyButton: true,
      showCancelButton: false,
      confirmButtonText: "Ja",
      denyButtonText: "Neen",
      confirmButtonColor: "red",
      denyButtonColor: "gray",
    });

    const id = item.id;
    if (result.isConfirmed) {
      
      await AXIOS_DELETE("adviezen", id)
        .then((result) => {
          if (result.status === 200) {
            // Create a reference to the file to delete
            const fileRef = ref(storage, item?.url);

            // Delete the file from Firebase Storage
            deleteObject(fileRef);
            Swal.fire({
              position: "top-end",
              icon: "success",
              title: `Bestand is goed verwijderd`,
              showConfirmButton: false,
              timer: 2500,
            });

            setRefresh(true);
          }
        })
        .catch((e) => {
          Swal.fire({
            position: "top-end",
            icon: "error",
            title: `er is iets mis gelopen`,
            showConfirmButton: false,
            timer: 2500,
          });
        });
    }
  };

  return (
    <div className="mx-auto w-full bg-wa-app px-4 pt-6 sm:px-6 lg:px-8">
      <div className="flex flex-col gap-3 md:flex-row md:items-center md:justify-between">
        <FilterNavigation
          selectedRadio={view}
          setSelectedRadio={setView}
          options={filters}
        />
        <div className="flex flex-col gap-2 md:flex-row md:items-end">
             { patienten?.length > 0 ? (
            <SelectPatienten
              selected={patient ? patient : patienten[0]}
              setSelected={setPatient}
              data={patienten}
              variant="wa"
            />
          ) : null}
          <button
              type="button"
              onClick={() => setOpen(true)}
              className="h-10 rounded-md bg-wa-accent px-4 py-2 text-center text-sm font-semibold text-wa-onaccent shadow-sm transition hover:bg-wa-accentdeep focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-wa-accent"
            >
              Voeg een document toe
            </button>
            </div>
      </div>
      {view?.value === 1 ? (
        <DashboardDocumenten
          attachments={attachments}
          setRefresh={setRefresh}
          deleteDocument={deleteDocument}
          setOpenModal={setOpen}
          patienten={patienten}
          patient={patient}
          user={userdetails}
        />
      ) : (
        <div className="mt-4 grid grid-cols-1 gap-3 md:grid-cols-2 xl:grid-cols-3 xxl:grid-cols-4">
          {attachments?.length > 0
            ? attachments.map((item) => (
               <div key={item?.id || item?.url || item?.bestand}>
                 <FileCardAdvies type={'advies'} item={item} deleteDocument={deleteDocument} userdetails={userdetails} />
               </div>
              ))
            : <div className="col-span-full rounded-lg border border-wa-border bg-wa-panel p-8 text-center text-wa-muted">
            <p>Er zijn geen documenten gevonden.</p>
          </div>}
        </div>
      )}
      <UploadDocumenten
        setRefresh={setRefresh}
        attachments={attachments}
        user={userdetails}
        patient={patient}
        open={open}
        setOpen={setOpen}
        type="advies"
      />
    </div>
  );
};

export default AdviezenAdmin;
